import * as _ from 'lodash';

export const groupedData = (data) => {
    var result = _.groupBy(data, function (obj) {
        if (obj) {
            return obj.Group;
        }
    });
    var d = [];
    $.each(result, function (index, obj) {
        var temp = {};
        if (Array.isArray(obj)) {
            obj.forEach(function (ele) {
                if (ele) {
                    if (temp[ele.FieldGroup || ele.LabelName])
                        temp[ele.FieldGroup || ele.LabelName].push(ele);
                    else {
                        temp[ele.FieldGroup || ele.LabelName] = [];
                        temp[ele.FieldGroup || ele.LabelName].push(ele);
                }
                }
            });
        }

        Object.keys(temp).forEach(function(key) {
            d.push(temp[key]);
            d.sort(function (a, b) {
                if(a.length > 1 || b.length > 1) {
                   if(a[0].Sequence < b[0].Sequence) { return -1; }
                   if(a[0].Sequence > b[0].Sequence){ return 1;} 
                }
                if (a.length == 1 && b.length == 1 && a[0].Sequence < b[0].Sequence) { return -1; }
                if (a.length == 1 && b.length == 1 && a[0].Sequence > b[0].Sequence) { return 1; }
                return 0;
            })
        });
    });
    return d;
}

export default {groupedData};